import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../../environments/environment';
import { PAGES_MENU } from '../pages.menu';
import moment from 'moment/src/moment';


@Injectable()
export class LoginService {
  private _authToken: string = '';
  private _isAdmin: Boolean = false;
  private _firstName: string = '';
  private _organization: string = '';
  private tokenExpiry;
  constructor(private http: Http) { }
  private apiUrl = environment.apiUrlV3;

  loginSAL1(values, siteUrl): Promise<any> {
    localStorage.setItem('email', values.email);
    let body = { username: values.email, password: values.password };
    let bodyString = JSON.stringify(body); // Stringify payload
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({ headers: headers });

      return this.http.post(`${this.apiUrl}/login`, bodyString, options).toPromise()
                       .then((res:Response) => {
                       let failure = JSON.parse(res['_body']);
                       if (res && res['_body'] && failure.status === 'error') {
                        return failure;
                       } else {
                        let respJson = res.json();
                        this._authToken = respJson.token;
                        this._isAdmin = respJson.user.is_saladmin;
                        this._organization = respJson.user.organization;
                        this.tokenExpiry = 1800000;
                        /*let respJson = res.json();
                        if (respJson && respJson.user) {
                          this._firstName = user.first_name;
                        } else {
                          this._firstName = "Alex Chai";
                        }*/
                        var adminCheck = this._isAdmin.toString();
                        localStorage.setItem('currentUser', this._authToken);
                        localStorage.setItem('firstName', respJson.user.first_name);
                        localStorage.setItem('username', respJson.user.username);
                        localStorage.setItem('isEnterpriseUser', respJson.user.is_enterprise_user)
                        localStorage.setItem('isBillingAdmin', respJson.user.is_billing_admin)
                        localStorage.setItem('isAdmin', adminCheck);
                        localStorage.setItem('organization', this._organization);
                        localStorage.setItem('tokenExpiry',this.tokenExpiry )
                        localStorage.setItem('PAGES_MENU', JSON.stringify(PAGES_MENU));
                        localStorage.setItem('spaceagemaptype', respJson.user.map_type);
                        this.token();
                        var loginTime = moment()
                        localStorage.setItem('LoginTime', loginTime);
                        return res.json();
                       }
                      })
                       .catch((error:any) => {Observable.throw(error.json().error || 'Server error')});
  }
  tokentimerObj;
  token() {
    var timerValue = parseFloat(localStorage.getItem('tokenExpiry'));
    this._authToken = localStorage.getItem('currentUser');
    var finalValue = timerValue;

    var tokenTimer = Observable.timer(finalValue, timerValue);
    this.tokentimerObj = tokenTimer.subscribe(t => {
      this.refreshToken(this._authToken).then((resp) => {
        this._authToken = resp.token;
        localStorage.setItem('currentUser', resp.token)
        localStorage.setItem('LoginTime', moment());
      });
    });

  }
  getOrgbillingInfo (organisation, auth): Promise<any> {
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json', Authorization: 'JWT ' + auth});
    apiEndPoint = `${this.apiUrl}/${organisation}/billing`
    let options = new RequestOptions({ headers: headers });

    return this.http.get(apiEndPoint,options).toPromise()
                .then((res:Response) => res.json())
                .catch((error:any) => Observable.throw(error.json().detail || 'Server error'));
  }
  testCOR(): Promise<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(`https://api.github.com/repos/vmg/redcarpet/issues?state=closed`, options).toPromise()
      .then((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
  getAuth() {
    return this._authToken || localStorage.getItem('currentUser');
  }
  getIsAdmin() {
    return this._isAdmin || localStorage.getItem('isAdmin');
  }
  getFirstName() {
    return this._firstName || localStorage.getItem('firstName');
  }
  getOrganization() {
    return this._organization || localStorage.getItem('organization');
  }
  getPagesMenu() {
    if (localStorage.getItem('PAGES_MENU')) {
      let maptype = localStorage.getItem('spaceagemaptype');
      let pages = JSON.parse(localStorage.getItem('PAGES_MENU'));
      let mapindex = pages[0].children[0].children.length;
      if (pages[0].children[0].children[pages[0].children[0].children.length - 1].path == 'gps' || pages[0].children[0].children[pages[0].children[0].children.length - 1].path == 'onemap') {
        mapindex = pages[0].children[0].children.length - 1;
      }
      if (maptype == 'onemap') {

        pages[0].children[0].children[mapindex] = {
          path: 'onemap',
          data: {
            menu: {
              title: 'OneMap Dashboard',
            }
          }
        };
      }
      else { //if(maptype == 'google')
        pages[0].children[0].children[mapindex] = {
          path: 'gps',
          data: {
            menu: {
              title: 'GPS Dashboard',
            }
          }
        }
      }
      return pages;
    }
    return '';
  }
  setPagesMenu(menu) {
    if (menu) {
      localStorage.setItem('PAGES_MENU', JSON.stringify(menu));
    }
  }
  /* 
	* fromDate : yyyy-MM-dd
	* toDate : yyyy-MM-dd
	*/
  getEnergyFeed(auth, organisation, fromDate, toDate): Promise<any> {
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json', Authorization: 'JWT ' + auth });
    apiEndPoint = `${this.apiUrl}/${organisation}/feeds/Energy/data-cumulative/${fromDate}/${toDate}`
    let options = new RequestOptions({ headers: headers });

    return this.http.get(apiEndPoint, options).toPromise()
      .then((res: Response) => res.json())
      .catch((error: any) => {
        return Promise.reject(error._body || 'Server error')
      });
  }
  resetPassword(values): Promise<any> {
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json' });
    apiEndPoint = `${this.apiUrl}/reset-password`
    let options = new RequestOptions({ headers: headers });
    let body = { email: values.resetEmail, organization: values.org };
    let bodyString = JSON.stringify(body);

    return this.http.post(apiEndPoint, bodyString, options).toPromise()
      .then((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }
  refreshToken(token): Promise<any> {
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json' });
    apiEndPoint = `${this.apiUrl}/refresh-jwt-token`
    let options = new RequestOptions({ headers: headers });
    let body = { token: token };
    let bodyString = JSON.stringify(body);

    return this.http.post(apiEndPoint, bodyString, options).toPromise()
      .then((res: Response) => {
        this._authToken = res.json().token;
        localStorage.setItem('currentUser', this._authToken);
        this.getAuth();
        return res.json()
      })
      .catch((error: any) => Observable.throw(error.json().detail || 'Server error'))
  }

  getOrgDashboards(auth, organisation): Promise<any> {
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json', Authorization: 'JWT ' + auth });
    apiEndPoint = `${this.apiUrl}/${organisation}/dashboards`
    let options = new RequestOptions({ headers: headers });

    return this.http.get(apiEndPoint, options).toPromise()
      .then((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().detail || 'Server error'));
  }
  addDashboard(values, auth, organisation): Promise<any> {
    let body = {};
    body = {
      name: values.dashboardName,
      public: values.dashboardState
    };
    if (values.key) body['key'] = values.key;
    if (values.description) body['description'] = values.description;
    if (values.data) body['data'] = values.data;

    let endPoint = this.apiUrl + `/${organisation}/dashboards`;;
    let bodyString = JSON.stringify(body); // Stringify payload
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'JWT ' + auth)
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${endPoint}`, bodyString, options).toPromise()
      .then((res: Response) => {
        return res.json();
      }).catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }
  editDashboard(values, auth, organisation): Promise<any> {
    let body = {};
    body = {
      name: values.dashboardName,
      public: values.dashboardState

    };
    if (values.key) body['key'] = values.key;
    if (values.description) body['description'] = values.description;
    if (values.data) body['data'] = values.data;

    let endPoint = this.apiUrl + `/${organisation}/dashboards/${values.key}`;;
    let bodyString = JSON.stringify(body); // Stringify payload
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'JWT ' + auth)
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${endPoint}`, bodyString, options).toPromise()
      .then((res: Response) => {
        return res.json();
      }).catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }

  deleteDashboard(dashboardId, auth, organisation): Promise<any> {
    let endPoint = this.apiUrl + `/${organisation}/dashboards/${dashboardId}`;;
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'JWT ' + auth)
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${endPoint}`, options).toPromise()
      .then((res: Response) => {
        return res.json();
      }).catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
  getConfig(organisation, auth): Promise<any> {
    let userName = localStorage.getItem('email');
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json', Authorization: 'JWT ' + auth });
    apiEndPoint = `${this.apiUrl}/${organisation}/users/${userName}/settings`
    let options = new RequestOptions({ headers: headers });

    return this.http.get(apiEndPoint, options).toPromise()
      .then((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().detail || 'Server error'));
  }
  getOrgDetails(organisation, auth): Promise<any> {
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json', Authorization: 'JWT ' + auth });
    apiEndPoint = `${this.apiUrl}/organizations/${organisation}`
    let options = new RequestOptions({ headers: headers });

    return this.http.get(apiEndPoint, options).toPromise()
      .then((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().detail || 'Server error'));
  }
  getOrgDevices(auth, organisation): Promise<any> {
    let headers, apiEndPoint;
    headers = new Headers({ 'Content-Type': 'application/json', Authorization: 'JWT ' + auth });
    apiEndPoint = `${this.apiUrl}/${organisation}/devices`
    let options = new RequestOptions({ headers: headers });

    return this.http.get(apiEndPoint, options).toPromise()
      .then((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().detail || 'Server error'));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.service.ts